module.exports = __webpack_public_path__ + "static/media/2010-2011 theme logo.4566babb.jpg";